/** Wire format for a survey link; the backend matches it literally. */
const SURVEY_PLACEHOLDER = '{{survey.link}}';

/**
 * Replaces any empty `<span class="survey-node-container"></span>` elements used as survey placeholders
 * (i.e., `<span class="survey-node-container"></span>`) with the
 * template placeholder string `{{survey.link}}`.
 *
 * @param {string} htmlString - The HTML content containing survey span nodes.
 * @returns {string} - Updated HTML with `{{survey.link}}` replacing survey spans.
 */
const replaceSurveySpanWithPlaceholder = (htmlString) => {
  return (
    htmlString?.replace(
      /<span[^>]*class=["']survey-node-container["'][^>]*><\/span>/gi,
      SURVEY_PLACEHOLDER
    ) || ''
  );
};

/**
 * True when the body already has a survey slot — either the interactive
 * node (`data-survey-select`, selected or not) or the still-unconverted
 * `{{survey.link}}` token. A body can only carry one; the variable picker
 * uses this to disable inserting a second, conflicting one (kept in the
 * allowlist so the existing token/node stays valid — see kula's
 * `editorProps.variable.disabledKeys`, and the same rule already enforced
 * this way in the comm-templates editor, `TemplateForm.tsx`).
 *
 * @param {string} htmlString
 * @returns {boolean}
 */
const hasSurveyPlaceholder = (htmlString) =>
  Boolean(
    htmlString?.includes('data-survey-select') ||
    htmlString?.includes(SURVEY_PLACEHOLDER)
  );

export {
  replaceSurveySpanWithPlaceholder,
  hasSurveyPlaceholder,
  SURVEY_PLACEHOLDER,
};
